var map = {
	"./auth/forgot-password.vue": 58214,
	"./auth/login.vue": 41609,
	"./auth/onboarding/about.vue": 87114,
	"./auth/onboarding/save-cashback.vue": 62347,
	"./auth/onboarding/savings-target.vue": 75076,
	"./auth/onboarding/spending-categories.vue": 39821,
	"./auth/personalize.vue": 44325,
	"./auth/reset-password.vue": 65713,
	"./auth/set-password.vue": 86233,
	"./auth/signup.vue": 25827,
	"./auth/verify-phone.vue": 82760,
	"./basket/index.vue": 9242,
	"./brand/index.vue": 70053,
	"./cashback/airtime/index.vue": 17347,
	"./cashback/cable/index.vue": 55725,
	"./cashback/data/index.vue": 80235,
	"./cashback/electricity/index.vue": 71014,
	"./cashback/gift_card/_id.vue": 69666,
	"./cashback/gift_card/index.vue": 84920,
	"./cashback/index.vue": 6098,
	"./index.vue": 16447,
	"./others/account_settings/index.vue": 98314,
	"./others/badges.vue": 7352,
	"./others/challenges/_id.vue": 87691,
	"./others/challenges/index.vue": 30175,
	"./others/challenges/word_twist/_id.vue": 73654,
	"./others/expense_tracker.vue": 35530,
	"./others/leaderboard.vue": 53015,
	"./others/levels.vue": 42397,
	"./others/membership.vue": 59191,
	"./others/new_point_earned.vue": 12404,
	"./others/notifications.vue": 6319,
	"./others/privacy_support/faqs.vue": 99186,
	"./others/privacy_support/index.vue": 74979,
	"./others/privacy_support/policy.vue": 32460,
	"./others/privacy_support/support.vue": 41141,
	"./others/privacy_support/terms.vue": 21652,
	"./others/referral.vue": 77809,
	"./others/rewards.vue": 89715,
	"./pay/initiate.vue": 77080,
	"./pay/merchant/index.vue": 32477,
	"./pay/user/index.vue": 65236,
	"./profile/edit.vue": 61607,
	"./profile/user.vue": 65678,
	"./savings/index.vue": 13500,
	"./savings/points/_id.vue": 26042,
	"./savings/topup.vue": 58412,
	"./savings/transactions.vue": 5480,
	"./savings/transactions/_id.vue": 87374,
	"./shoplist/_id.vue": 34403,
	"./shoplist/brands.vue": 3770,
	"./shoplist/checkout/_id.vue": 13232,
	"./shoplist/featured.vue": 25046,
	"./shoplist/index.vue": 76077,
	"./shoplist/items.vue": 20401,
	"./shoplist/product/_id.vue": 92161,
	"./shoplist/products.vue": 64185,
	"./snap/index.vue": 81455,
	"./snap/info.vue": 10124,
	"./start/index.vue": 27435,
	"./story/index.vue": 84514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89464;